/**
 * Sentlo Version Information
 * Update this file when releasing new versions
 */

export const APP_VERSION = '10.4.1';
export const VERSION_DATE = '2026-03-18';
export const VERSION_NAME = 'Module Loading Fix';

export const VERSION_HISTORY = [
  {
    version: '10.4.1',
    date: '2026-03-18',
    name: 'Module Loading Fix',
    changes: [
      'Fixed "Failed to fetch dynamically imported module" error',
      'Added comprehensive ErrorBoundary component',
      'Added AppHealthCheck diagnostic tool',
      'Improved cache busting mechanism',
      'Enhanced error logging and debugging'
    ]
  },
  {
    version: '10.4.0',
    date: '2026-03-18',
    name: 'User Posts Display Fix',
    changes: [
      'Fixed issue where new user posts weren\'t displaying',
      'Implemented immediate post visibility',
      'Added force refresh after post creation',
      'Improved mergeReports function',
      'Added periodic backend syncing every 60 seconds'
    ]
  },
  {
    version: '10.3.0',
    date: '2026-03-17',
    name: 'Comments System Update',
    changes: [
      'Full comment and reply system enabled',
      'Enhanced interaction features',
      'Improved post engagement tracking'
    ]
  },
  {
    version: '10.2.1',
    date: '2026-03-16',
    name: 'UX Improvements Wave 1',
    changes: [
      'Location badges on all posts',
      'Search filter banner active',
      'Enhanced visual feedback'
    ]
  },
  {
    version: '10.1.3',
    date: '2026-03-14',
    name: 'Error Handling Fix',
    changes: [
      'Fixed "Failed to fetch user profile" error',
      'Graceful network error handling',
      'Silent profile fetch when backend unavailable',
      'All post types show immediately'
    ]
  },
  {
    version: '10.0.8',
    date: '2026-03-12',
    name: 'Complete Dynamic Import Elimination',
    changes: [
      'Eliminated ALL dynamic imports',
      'All components imported at top level',
      'Mega aggressive build config',
      'inlineDynamicImports: true',
      'No code splitting'
    ]
  }
];

export function getVersionInfo() {
  return {
    version: APP_VERSION,
    date: VERSION_DATE,
    name: VERSION_NAME,
    full: `v${APP_VERSION} - ${VERSION_NAME} (${VERSION_DATE})`
  };
}

export function logVersionInfo() {
  console.log(`🚀 Sentlo v${APP_VERSION} - ${VERSION_NAME}`);
  console.log(`📅 Release Date: ${VERSION_DATE}`);
  console.log('📋 Recent Changes:');
  VERSION_HISTORY[0].changes.forEach(change => {
    console.log(`   ✅ ${change}`);
  });
}
